import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { affectVehicle, unassignVehicle } from "../services/vehiculeApi";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { CarOutlined, LinkOutlined } from "@ant-design/icons";
import { getUsers } from "../../Users/services/userApi";
import SelectField from "../../../Components/Common/Form/SelectField";
import "../../Styles/style.css";

const AffectVehicleForm = ({
  modal,
  setModal,
  toggle,
  selectedVehicule,
  actualDriver,
}) => {
  const queryClient = useQueryClient();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [confirmUnassign, setConfirmUnassign] = useState(false);
  const [isUnassigning, setIsUnassigning] = useState(false);

  const { isLoading, isError, data: users } = useQuery("users", getUsers);
  const drivers = users?.filter((user) => user.role?.name === "DRIVER");

  const nameVehicle = selectedVehicule?.brand || "-";

  const validationSchema = Yup.object().shape({
    driver: Yup.string().required("Veuillez choisir un chauffeur"),
  });

  const initialValues = selectedVehicule
    ? {
        name: selectedVehicule.brand,
        driver: selectedVehicule.actualUserId || "",
      }
    : {
        name: "",
        driver: "",
      };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      setIsLoadingSubmit(true);
      try {
        await affectVehicle(values.driver, selectedVehicule.id);

        toast.success("La voiture a été affectée avec succès");

        await queryClient.invalidateQueries("vehicules");

        toggle();
        formik.resetForm();
      } catch (error) {
        console.error(error);
        toast.error("Erreur lors de l'affectation");
      } finally {
        setIsLoadingSubmit(false);
      }
    },
  });

  const confirmUnassignVehicle = async () => {
    if (!selectedVehicule?.id || !selectedVehicule?.actualUserId) {
      toast.error("Aucun chauffeur à désaffecter");
      return;
    }

    try {
      setIsUnassigning(true);

      await unassignVehicle(
        selectedVehicule.actualUserId,
        selectedVehicule.id
      );

      toast.success("Véhicule désaffecté avec succès");

      await queryClient.invalidateQueries("vehicules");

      setConfirmUnassign(false);
      toggle();
      formik.resetForm();
    } catch (error) {
      console.error("Erreur désaffectation :", error);
      toast.error("Erreur lors de la désaffectation");
    } finally {
      setIsUnassigning(false);
    }
  };

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedVehicule]);

  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggle}
        centered
        backdrop="static"
        style={{ maxWidth: "800px" }}
      >
        <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
          <LinkOutlined /> Affectation du véhicule {nameVehicle} à un chauffeur
        </ModalHeader>

        <Form onSubmit={formik.handleSubmit}>
          <ModalBody>
            <Row>
              <Col lg={6}>
                <label className="form-label">
                  Véhicule <CarOutlined />
                </label>
                <input
                  className="form-control"
                  value={formik.values.name}
                  disabled
                />
              </Col>

              <Col lg={6}>
                <label className="form-label">Actuel Chauffeur</label>
                <input
                  className="form-control"
                  value={actualDriver}
                  disabled
                />
              </Col>

              <SelectField
                label="Chauffeur"
                name="driver"
                formik={formik}
                isLoading={isLoading}
                isError={isError}
                options={drivers}
                nameSelect="Un nouveau chauffeur pour ce véhicule"
                error={formik.errors.driver}
                colSize={12}
                isName={false}
              />
            </Row>
          </ModalBody>

          <ModalFooter className="d-flex justify-content-between align-items-center">
            <Button color="danger" onClick={() => setConfirmUnassign(true)}>
              Désaffecter
            </Button>

            <div className="d-flex gap-2">
              <Button color="light" onClick={() => setModal(false)}>
                Annuler
              </Button>

              <Button
                type="submit"
                className="active-tab"
                disabled={isLoadingSubmit}
              >
                {isLoadingSubmit ? <Spin size="small" /> : "Affecter"}
              </Button>
            </div>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={confirmUnassign} centered>
        <ModalHeader>Confirmation</ModalHeader>

        <ModalBody>
          Voulez-vous vraiment désaffecter ce véhicule ?
        </ModalBody>

        <ModalFooter>
          <Button
            color="light"
            onClick={() => setConfirmUnassign(false)}
            disabled={isUnassigning}
          >
            Annuler
          </Button>

          <Button
            color="danger"
            onClick={confirmUnassignVehicle}
            disabled={isUnassigning}
          >
            {isUnassigning ? <Spin size="small" /> : "Oui, désaffecter"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AffectVehicleForm;